export default {"src":"/_next/static/media/Mastercard.afb6366e.svg","height":22,"width":34};